/** @copy-from https://gitlab.poski.com/poskireal/poskireal.cz/-/blob/07456af8b2b7090b0ed8294c58737da301e2468b/frontend/CID/poski/v25.6/klasik/js/nemovitost-5-views.js */
// Načítání virtuální prohlídky a videoprohlídky
const inicializedVideoPlayers = new Set();

function createIframe(src) {
    const iframe = document.createElement("iframe");
    iframe.src = src;
    iframe.frameBorder = "0";
    iframe.allowFullscreen = true;
    iframe.allow = "autoplay; encrypted-media";
    return iframe;
}

function createVideo(src) {
    const video = document.createElement("video");
    video.src = src;
    video.controls = true;
    video.autoplay = true;
    return video;
}

function loadPlayer(el) {
    const {type, id} = el.dataset;
    if (inicializedVideoPlayers.has(el)) {
        return;
    }
    inicializedVideoPlayers.add(el);
    const playerTypes = {
        matterport: () => createIframe(`${id}${id.includes("?") ? "&" : "?"}play=1`),
        youtube: () => createIframe(`https://www.youtube.com/embed/${id}?autoplay=1`),
        video: () => createVideo(id)
    };
    if (playerTypes[type]) {
        el.innerHTML = "";
        el.appendChild(playerTypes[type]());
    }
}

function stopAllPlayers(excludeElement) {
    document.querySelectorAll(".view-player").forEach(el => {
        if (excludeElement && excludeElement.contains(el)) {
            return;
        }
        const video = el.querySelector("video");
        if (video) {
            video.pause();
        }
        const iframe = el.querySelector("iframe");
        if (iframe) {
            const src = iframe.src;
            if (src.includes("autoplay=1")) {
                iframe.src = "";
                iframe.src = src.replace("autoplay=1", "autoplay=0");
            }
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".view-player").forEach(el => {
        el.addEventListener("click", () => loadPlayer(el));
    });
});

window.stopAllPlayers = stopAllPlayers;